import _Vue from "vue";
import UyapClient from "./uyap/UyapClient";

export default function UyapClientPlugin(Vue: typeof _Vue): void {
    // do stuff with options
    Vue.prototype.$uyap = new UyapClient();
}
